import { roomImages } from "./roomImages";


const  hero1 = roomImages.dreamland.heroslider[0];
const  hero2 = roomImages.dreamland.heroslider[1];
const  hero3 = roomImages.dreamland.heroslider[2];


export const heroSlides = [
  {
    id: 2,
    image: hero2,
    title: 'Welcome to Dreamland Inn',
    subtitle: 'An Evening at Dreamland',
  },
  {
    id: 3,
    image: hero3,
    title: 'Welcome to Dreamland Inn',
    subtitle: '2, 3, 4, 6 and 8 Bedded Rooms',
  },
    {
    id: 1,
    image: hero1,
    title: 'Welcome to Dreamland Inn',
    subtitle: 'Cottages Right on the Beach',
  }
];

export const services = [
  {
    id: 1,
    icon: 'Waves',
    title: 'Pool & Beach Access',
    description: 'Enjoy our swimming pool and direct beach access right at your doorstep.',
  },
  {
    id: 2,
    icon: 'Wind',
    title: 'Air Conditioning',
    description: 'All rooms are equipped with air conditioning for your comfort.',
  },
  {
    id: 3,
    icon: 'Wifi',
    title: 'Wi-Fi & Internet',
    description: 'Stay connected with high-speed Wi-Fi available throughout the property.',
  },
  {
    id: 4,
    icon: 'UtensilsCrossed',
    title: 'Restaurant & Room Service',
    description: 'Enjoy authentic Konkani veg and non-veg food at our restaurant or via room service.',
  },
  {
    id: 5,
    icon: 'ConciergeBell',
    title: '24-Hour Front Desk',
    description: 'Our front desk is available round the clock to assist you with any needs.',
  },
  {
    id: 6,
    icon: 'Car',
    title: 'Parking & Shuttle',
    description: 'Free parking on-site with airport shuttle and local shuttle services available.',
  },
  {
    id: 7,
    icon: 'Baby',
    title: 'Child Friendly',
    description: 'A safe and fun environment for children — we love having young guests!',
  },
  {
    id: 8,
    icon: 'PawPrint',
    title: 'Pet Friendly',
    description: 'Your furry friends are welcome too! Bring your pets along for a comfortable stay.',
  }
];

export const aboutData = {
  image: hero2,
  paragraphs: [
    'Welcome to Dreamland Inn. Seaside cottages surrounded by nature. The destination you were dreaming of. Surrounded by lush green lawns & hundreds of coconut trees presents a typical Konkani village. Located near Dapoli at a famous beach Murud, Dreamland Inn is full of ocean breeze.',
    'Fronted by a peaceful beach of Murud where you can enjoy a sun bath, sea bath & experience a typical sunset even sitting in front of your cottages. The panoramic view will gift you a golden memory of your life.',
    'Ten years of experience has set us up in an expanding horizon of the most developing tourism industry in Konkan. We will be happy to welcome you to Murud along with your friends & family and assure you the best facilities with the tradition of hospitality. Amazing Konkan is waiting for you...'
  ]
};

export const foodItems = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1742281258189-3b933879867a?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Pure Veg',
    description: 'Traditional Konkani vegetarian delicacies'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1738291422837-85761f82a10e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBjb2FzdGFsJTIwZm9vZHxlbnwwfHx8fDE3NzYxNDcxMzV8MA&ixlib=rb-4.1.0&q=85',
    title: 'Non Veg',
    description: 'Fresh seafood and authentic Konkani non-veg'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1630870487699-1a6d8b24cc1f?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Desserts',
    description: 'Sweet endings with local Konkani flavors'
  }
];

export const stats = [
  { id: 1, value: 14, suffix: '+', label: 'Years of Experience' },
  { id: 2, value: 26, suffix: '', label: 'Cottages' },
  { id: 3, value: 9, suffix: 'K+', label: 'Happy Customers' },
  { id: 4, value: 5, suffix: '', label: 'Star Rating' },
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Sharma',
    location: 'Mumbai',
    rating: 5,
    text: 'An amazing experience! The beachfront cottages are serene and the food was absolutely delicious. The staff was very warm and helpful. Will definitely visit again!',
    avatar: 'RS'
  },
  {
    id: 2,
    name: 'Priya Deshmukh',
    location: 'Pune',
    rating: 5,
    text: 'We celebrated our anniversary here and it was magical. The sunset views from the cottage were breathtaking. The Konkani food reminded me of my grandmother\'s cooking.',
    avatar: 'PD'
  },
  {
    id: 3,
    name: 'Amit Kulkarni',
    location: 'Nashik',
    rating: 4,
    text: 'A perfect getaway from city life. The kids loved the game zone and the beach was clean and beautiful. Great value for money. Highly recommend for families!',
    avatar: 'AK'
  },
  {
    id: 4,
    name: 'Sneha Patil',
    location: 'Kolhapur',
    rating: 5,
    text: 'Dreamland Inn truly lives up to its name. Waking up to the sound of waves and the smell of coconut trees was a dream come true. The hospitality was outstanding!',
    avatar: 'SP'
  },
];

// Foods
import fish from '../assets/gallery/Dreamland/Foods/fish.webp';
import misalPav from '../assets/gallery/Dreamland/Foods/misalpav.webp';
import misalPav1 from '../assets/gallery/Dreamland/Foods/misalpav1.webp';
import modak from '../assets/gallery/Dreamland/Foods/modak.webp';
import thali from '../assets/gallery/Dreamland/Foods/Thalinonveg.webp';
import veg from '../assets/gallery/Dreamland/Foods/veg.webp';

// Others
import around from '../assets/gallery/Dreamland/others/around.webp';
import gate from '../assets/gallery/Dreamland/others/gate.webp';
import playground from '../assets/gallery/Dreamland/others/playground.webp';
import sunset from '../assets/gallery/Dreamland/others/sunset.jpg';
import view from '../assets/gallery/Dreamland/others/view.webp';
import view2 from '../assets/gallery/Dreamland/others/view2.webp';

// beach
import beach1 from '../assets/gallery/Dreamland/Beach/view1.jpg';
import beach2 from '../assets/gallery/Dreamland/Beach/view2.jpg';


export const galleryImages = [


  // RESORT
  { id: 7, src: around, alt: 'Resort Surroundings', category: 'resort' },
  { id: 8, src: gate, alt: 'Resort Gate', category: 'resort' },
  { id: 9, src: playground, alt: 'Playground', category: 'resort' },
  { id: 10, src: sunset, alt: 'Sunset View', category: 'resort' },
  { id: 11, src: view, alt: 'Resort View', category: 'resort' },
  { id: 12, src: view2, alt: 'Resort View 2', category: 'resort' },

      // beach
  { id: 13, src: beach1, alt: 'Resort beach', category: 'beach' },
  { id: 14, src:  beach2, alt: 'Resort beach', category: 'beach' },

    // FOOD
  { id: 1, src: fish, alt: 'Fish Dish', category: 'food' },
  { id: 2, src: misalPav, alt: 'Misal Pav', category: 'food' },
  { id: 3, src: misalPav1, alt: 'Misal Pav Variation', category: 'food' },
  { id: 4, src: modak, alt: 'Modak Sweet', category: 'food' },
  { id: 5, src: thali, alt: 'Non-Veg Thali', category: 'food' },
  { id: 6, src: veg, alt: 'Veg Dish', category: 'food' },



  // ROOMS (auto from roomImages)
  ...roomImages.dreamland.seaFacing.slice(0, 1).map((img, i) => ({
    id: 100 + i,
    src: img,
    alt: 'Sea Facing Room',
    category: 'rooms'
  })),

  ...roomImages.dreamland.cottageRoom.slice(0, 0).map((img, i) => ({
    id: 110 + i,
    src: img,
    alt: 'Cottage Room',
    category: 'rooms'
  })),

  ...roomImages.dreamland.deluxeRoom.slice(0, 0).map((img, i) => ({
    id: 120 + i,
    src: img,
    alt: 'Deluxe Room',
    category: 'rooms'
  })),

  ...roomImages.dreamland.coupleRoom.slice(0, 0).map((img, i) => ({
    id: 130 + i,
    src: img,
    alt: 'Couple Room',
    category: 'rooms'
  })),

  ...roomImages.dreamland.largeFamilyRoom.slice(0, 1).map((img, i) => ({
    id: 140 + i,
    src: img,
    alt: 'Large Family Room',
    category: 'rooms'
  })),
];

import room1 from "../assets/roomsimages/Dreamland/room1.jpg";


export const rooms = [
  {
    id: 1,
    name: 'Sea Facing Room',
    beds: '4 Bedded',
    price: {
      ac: '4,000',
      nonAc: '3,500'
    },
   images: roomImages.dreamland.seaFacing.slice(0, 3),
    amenities: ['Sea View', 'AC', 'Wi-Fi'],
    description: 'Sea facing room with beautiful beach view, ideal for families.'
  },
  {
    id: 2,
    name: 'Deluxe Room ',
    beds: '5 Bedded',
    price: {
      ac: '4,000',
      nonAc: '3,500'
    },
images: roomImages.dreamland.deluxeRoom.slice(0, 3),
    amenities: ['AC', 'Wi-Fi'],
    description: 'Spacious deluxe room suitable for family stay.'
  },
  {
    id: 3,
    name: 'Cottage Room',
    beds: '3 Bedded',
    price: {
      ac: '3,500',
      nonAc: '3,000'
    },
  images: roomImages.dreamland.cottageRoom.slice(0, 3),
    amenities: ['AC', 'Wi-Fi'],
    description: 'Peaceful cottage stay with a cozy environment.'
  },
  {
    id: 4,
    name: 'Couple Room',
    beds:'',
    price: {
      ac: '3,500',
      nonAc: '3,000'
    },
images: roomImages.dreamland.coupleRoom.slice(0, 3),
    amenities: ['AC', 'Wi-Fi'],
    description: 'Perfect for couples looking for a relaxing stay.'
  },
  {
    id: 5,
    name: 'Group Room',
    beds: '6 Bedded',
    price: {
      ac: '4,500',
      nonAc: '4,000'
    },
   images: roomImages.dreamland.megaGroupRoom.slice(0, 3),
    amenities: ['AC', 'Wi-Fi'],
    description: 'Ideal for group stays with comfortable space.'
  },
  {
    id: 6,
    name: 'Large Family Room',
    beds: '8 Bedded',
    price: {
      nonAc: '5,500'
    },
   images: roomImages.dreamland.largeFamilyRoom.slice(0, 3),
    amenities: ['Wi-Fi'],
    description: 'Best for large families with spacious accommodation.'
  },
  {
    id: 7,
    name: 'Mega Group Room',
    beds: '10 Bedded',
    price: {
      nonAc: '6,000'
    },
   images: roomImages.dreamland.megaGroupRoom.slice(0, 3),
    amenities: ['Wi-Fi'],
    description: 'Perfect for big groups and events.'
  }
];


export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/#about' },
  { label: 'Rooms', href: '/#rooms' },
  { label: 'Destination Events', href: '/#events' },
  { label: 'Gallery', href: '/#gallery' },
  { label: 'Contact Us', href: '/#contact' },
];

export const contactInfo = {
  phone: '+91 9422476222',
  email: 'Dreamlandinn27@gmail.com',
  address: 'Dreamland Inn, Murud Beach, Dapoli, Ratnagiri, Maharashtra 415712',
  whatsapp: '9422476222',
  reception: [9423296526,9404992515], 
  facebook: 'https://facebook.com/dreamlandinn',
  instagram: 'https://www.instagram.com/dreamland_inn/',
  mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3797.0!2d73.1130929!3d17.7727996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be9c3dbfffffff9%3A0x74bc5600653a8a4c!2sDreamland%20Inn!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin'
};
export const destinationEvents = [
  {
    id: 1,
    title: "Royal Weddings",
    description: "Celebrate your union in grand Haveli style with floral mandaps, candlelit courtyards, and bespoke décor.",
    image: "https://images.unsplash.com/photo-1587271636175-90d58cdad458?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    title: "Mehendi & Sangeet",
    description: "Vibrant pre-wedding festivities with traditional rituals, live music, and an open courtyard setting.",
    image: "https://images.unsplash.com/photo-1505932794465-147d1f1b2c97?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    title: "Corporate Events",
    description: "Conferences, team offsites, product launches — professional setups with Haveli warmth.",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87",
  },
  {
    id: 4,
    title: "Birthday Parties",
    description: "From intimate gatherings to grand bashes — every detail handled with care.",
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d",
  },
  {
    id: 5,
    title: "Candlelight Dinners",
    description: "A private table for two, curated cuisine, fairy lights, and an atmosphere made for romance.",
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0",
  },
  {
    id: 6,
    title: "Cultural Evenings",
    description: "Folk performances, traditional music, and storytelling beneath the open sky.",
    image: "https://images.unsplash.com/photo-1504196606672-aef5c9cefc92",
  },
];

export const allEventTypes = [
  "Engagement Ceremonies",
  "Anniversary Celebrations",
  "Baby Showers",
  "Kitty Parties",
  "Team Retreats",
  "Family Reunions",
  "Bachelorette Parties",
  "Pool Parties",
  "Naming Ceremonies",
  "Farewell Parties",
  "Alumni Gatherings",
  "Puja & Religious Ceremonies",
  "Product Launches",
  "Photoshoots",
  "Pre-Wedding Shoots",
  "Retirement Parties",
  "Award Nights",
  "Fashion Shows",
  "Workshop & Seminars",
  "Music Nights",
];